module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "hdchart",
    attrs: {
      "id": "my-component-hdchart"
    },
    on: {
      "mousemove": function($event) {
        return _vm.move($event)
      },
      "mousedown": function($event) {
        return _vm.down($event)
      }
    }
  }, [_vm._v("您的设备不支持canvas")]), _vm._v("\n\t" + _vm._s(_vm.points) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e419218!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/chart/index.vue
// module id = 95
// module chunks = 0